 import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { HttpService } from '../../../shared-services/http.service';


@Injectable({ providedIn: 'root' })
export class MenuService {
  constructor(
    private apiServiceRequest: HttpService,
    private _http: HttpClient) {
  }

  async GetUserMenu() {
    const baseurl = '/api/Menu/GetUserMenu';
    return await this.apiServiceRequest.getAllLocal(baseurl).toPromise();
  }
  async GetUserInfo() {
    const baseurl = '/api/Menu/GetUserInfo';
    return await this.apiServiceRequest.getAllLocal(baseurl).toPromise();
  }
  async SetToken(model: any) {
    const baseurl = '/api/Auth/SetToken';
    return await this.apiServiceRequest.SendLocal(baseurl, model).toPromise();
  }
  async Logout() {
    const baseurl = '/api/Auth/Logout';
    return await this.apiServiceRequest.SendLocal(baseurl, {}).toPromise();
  }
}




